import React from "react";
import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import Seo from "@/components/Seo";
import { PARTNERS } from "@/data/services";

const PartnersPage = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo titleKey="seo.partners_title" descKey="seo.partners_desc" path="/partenaires" />
      <section className="container-x pt-14 pb-10">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-blue">{t("nav.partners")}</p>
        <h1 className="mt-2 font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl text-slate-900">
          {t("partners.title")}
        </h1>
        <p className="mt-4 text-slate-600 text-base sm:text-lg max-w-3xl leading-relaxed">
          {t("partners.subtitle")}
        </p>
      </section>

      <section className="container-x py-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6">
        {PARTNERS.map((p) => (
          <div
            key={p.name}
            className="group rounded-2xl border border-slate-200 bg-white px-6 py-8 flex flex-col items-center justify-center gap-3 ring-soft hover:shadow-md transition-shadow"
            data-testid={`partner-card-${p.name.replace(/\s+/g, "-").toLowerCase()}`}
          >
            {p.logo ? (
              <img
                src={p.logo}
                alt={p.name}
                className="max-h-[60px] w-auto object-contain"
              />
            ) : (
              <Building2 className="h-8 w-8 text-brand-blue" />
            )}
            <div className="font-heading font-semibold text-slate-700 text-xs uppercase tracking-wider text-center">
              {p.name}
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default PartnersPage;
